import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import '@web/shared-digital-library/icons/svg-originals/cb.svg';
import '@web/shared-digital-library/icons/svg-originals/mastercard.svg';
import '@web/shared-digital-library/icons/svg-originals/visa.svg';
import '@web/shared-digital-library/icons/svg-originals/paypal.svg';
import '@web/shared-digital-library/icons/svg-reinsurance/alma.svg';
import '@web/shared-digital-library/icons/svg-originals/bank_transfer_fr.svg';
import '@web/shared-digital-library/icons/svg-originals/bank_transfer_de.svg';
import '@web/shared-digital-library/icons/svg-originals/bank_transfer_en.svg';
import '@web/shared-digital-library/icons/svg-originals/bank_transfer_es.svg';
import '@web/shared-digital-library/icons/svg-originals/bank_transfer_it.svg';
import '@web/shared-digital-library/icons/svg-originals/bank_transfer_nl.svg';
import '@web/shared-digital-library/icons/svg-originals/bank_transfer_pt.svg';
import '@web/shared-digital-library/icons/svg-originals/bank_check.svg';
import '@web/shared-digital-library/icons/svg-originals/ideal.svg';
import '@web/shared-digital-library/icons/svg-originals/sofort.svg';
import '@web/shared-digital-library/icons/svg-originals/bcmc.svg';
import '@web/shared-digital-library/icons/svg-originals/sequra.svg';
import '@web/shared-digital-library/icons/svg-originals/maestro.svg';
export default {
  name: 'Payment',
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: {
    setLanguage: function setLanguage(link) {
      if (link === 'bank_transfer') {
        return "_".concat(this.locale.language);
      }
      return '';
    }
  }
};